import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { BackupPolicyType, Condition, ResourceType } from '@repo/api-gw-sdk';
import type { FilterProperty } from '@/types/advanceFilter';
import { ResourceSelectionDynamicViewer, type ResourcesScopeType } from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualViewer } from './resourceSelectionManualViewer';
export const ResourcesSelectionViewer = t0 => {
  const $ = _c(20);
  const {
    condition,
    conditionTitle,
    resourcesScopeType,
    include,
    exclude,
    dynamicResourcesHeader,
    allExcludedDescription,
    allIncludedDescription,
    supportProperties,
    selectedResourceTypes,
    policyType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "40px",
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "24px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== allExcludedDescription || $[3] !== allIncludedDescription || $[4] !== condition || $[5] !== conditionTitle || $[6] !== policyType || $[7] !== resourcesScopeType || $[8] !== selectedResourceTypes || $[9] !== supportProperties) {
    t3 = <ResourceSelectionDynamicViewer condition={condition} conditionTitle={conditionTitle} resourcesScopeType={resourcesScopeType} allExcludedDescription={allExcludedDescription} allIncludedDescription={allIncludedDescription} supportProperties={supportProperties} selectedResourceTypes={selectedResourceTypes} policyType={policyType} />;
    $[2] = allExcludedDescription;
    $[3] = allIncludedDescription;
    $[4] = condition;
    $[5] = conditionTitle;
    $[6] = policyType;
    $[7] = resourcesScopeType;
    $[8] = selectedResourceTypes;
    $[9] = supportProperties;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== dynamicResourcesHeader || $[12] !== t3) {
    t4 = <Stack sx={t2}>{dynamicResourcesHeader}{t3}</Stack>;
    $[11] = dynamicResourcesHeader;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== exclude || $[15] !== include) {
    t5 = include.length + exclude.length > 0 && <ResourceSelectionManualViewer include={include} exclude={exclude} />;
    $[14] = exclude;
    $[15] = include;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <Stack sx={t1}>{t4}{t5}</Stack>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};